import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import SvgIcon from '../SvgIcon/SvgIcon.js';

const Accordion = _ref => {
  let {
    id,
    expanded,
    header,
    title,
    content,
    gutter,
    expandIcon,
    rounded,
    duration,
    onChange,
    className
  } = _ref;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsxs(Container, {
      className: className,
      $expanded: expanded,
      $rounded: rounded,
      $gutter: gutter,
      children: [/*#__PURE__*/jsx(motion.div, {
        className: "accordion-header",
        onClick: () => onChange(!expanded ? id : undefined),
        children: header || /*#__PURE__*/jsxs(StyledTitle, {
          $expanded: expanded,
          $duration: duration,
          children: [/*#__PURE__*/jsx(SvgIcon, {
            type: expandIcon,
            width: "14",
            height: "14"
          }), title]
        })
      }), /*#__PURE__*/jsx(AnimatePresence, {
        initial: false,
        children: expanded && /*#__PURE__*/jsx(motion.section, {
          className: "accordion-content",
          initial: "collapsed",
          animate: "open",
          exit: "collapsed",
          variants: {
            open: {
              opacity: 1,
              height: 'auto'
            },
            collapsed: {
              opacity: 0,
              height: 0
            }
          },
          transition: {
            duration,
            ease: 'easeOut'
          },
          children: content
        }, "content")
      })]
    })
  });
};
const Container = styled.div`
  margin-top: ${_ref2 => {
  let {
    $gutter
  } = _ref2;
  return `${$gutter}px`;
}};
  font-family: ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fonts.InterRegular;
}};
  font-weight: 500;
  line-height: 1.5;

  .accordion-header {
    background: ${_ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.white;
}};
    border-radius: ${_ref5 => {
  let {
    $rounded,
    $expanded
  } = _ref5;
  return $expanded && $rounded ? '4px 4px 0 0' : $rounded ? '4px' : 0;
}};
    cursor: pointer
  }

  .accordion-content {
    background: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.white;
}};
  }
`;
const StyledTitle = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  padding: 16px 0;

  svg {
    margin: auto 8px auto 16px;
    transform: ${_ref7 => {
  let {
    $expanded
  } = _ref7;
  return $expanded ? 'rotate(0deg)' : 'rotate(-90deg)';
}};
    transition-duration: ${_ref8 => {
  let {
    $duration
  } = _ref8;
  return $duration;
}}s;
  }
`;
Accordion.defaultProps = {
  id: '',
  className: '',
  expanded: false,
  rounded: false,
  header: null,
  title: '',
  content: '',
  expandIcon: 'caretDown',
  gutter: 0,
  duration: 0.2,
  onChange: null
};
Accordion.propTypes = {
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  expanded: PropTypes.bool,
  expandIcon: PropTypes.string,
  rounded: PropTypes.bool,
  gutter: PropTypes.number,
  duration: PropTypes.number,
  header: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func
};
var Accordion$1 = Accordion;

export { Accordion$1 as default };
//# sourceMappingURL=Accordion.js.map
